/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const CREATE_TENANT_LOGO_IMAGE = gql`
  mutation CreateTenantLogoImage($data: CreateTenantLogoImageInput!) {
    createTenantLogoImage(data: $data) {
      url
    }
  }
`
